import { Component, AfterViewInit, OnInit, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators, AbstractControl } from '@angular/forms';
import { FarmService } from '../farm.service';
import { Farm } from 'src/app/shared/dtos/Farm';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/util/services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home-farms',
  templateUrl: './home-farms.component.html',
  styleUrls: ['./home-farms.component.css']
})
export class HomeFarmsComponent implements OnInit, AfterViewInit {

  myForm: FormGroup;
  panelOpenState = false;

  allFarms: Farm[];
  numberFarms = 0;
  reloadFarms: Farm[];

  loading = true;

  constructor(
    private fb: FormBuilder,
    private farmService: FarmService,
    private notificationService: NotificationService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.createFormInputs();
    this.getFarms();
  }

  getFarms() {
    this.farmService.getFarms().subscribe(
      (farms) => {
        this.allFarms = farms;
        this.numberFarms = this.allFarms.length;
        this.loading = false;
      },
      () => {
        this.notificationService.showError(this.translate.instant('ERROR_GET_ALL_FARMS'), 5);
      }
    );
    this.allFarms = this.reloadFarms;

  }

  ngAfterViewInit(): void {
  }

  createFormInputs() {
    this.myForm = this.fb.group(
         {
          province          : new FormControl(),
          townHall          : new FormControl(),
          district          : new FormControl(null),
          municipality      : new FormControl(null),
          exploitations     : new FormArray([]),
          objectives        : new FormArray([]),
          areaMin           : new FormControl(0),
          areaMax           : new FormControl(1000),
          accessRoad        : new FormControl(null),
          country           : new FormControl('es', [Validators.required]),
      });
  }

  resetForm(){
    this.myForm.reset();
    let x  = this.myForm.getRawValue();
    this.myForm.controls.objectives.reset();
    console.log(this.myForm);
  }

  onSubmit(){
    const farmFilter = this.myForm.getRawValue();
    farmFilter.accessRoad = farmFilter.accessRoad === 'null' ? null : farmFilter.accessRoad;
    Object.keys(farmFilter).forEach((key) => (farmFilter[key] == null) && delete farmFilter[key]);
    this.farmService.filterFarms(farmFilter).subscribe(
      (farms) => {
        this.notificationService.showSuccess(this.translate.instant('SUCCESS_FILTER_FARMS'), 5);
        this.allFarms = [];
        this.allFarms = farms;
        this.numberFarms = this.allFarms.length;
        this.reloadFarms = farms;
        this.panelOpenState = false;

      },
      () => {
        this.notificationService.showError(this.translate.instant('ERROR_FILTER_FARMS'), 5);
      }
    );
  }

}
